import React from "react";
/**
 * Render TA tabs (labor/equipment/materials)
 * @param {Object} props
 */
function AdrTentativeAgreementModalTabsV3(props) {
  const { tabs, selectTab, selectedTabId, laborsClient, equipmentClient, materialsView } =
    props;

  const renderCount = (tabId) => {
    switch (tabId) {
      case "labor":
        return Object.values(laborsClient).filter((lc) => !lc.excludeFromTa).length;
      case "equipment":
        return Object.values(equipmentClient).filter((ec) => !ec.excludeFromTa).length;
      case "materials":
        return Object.values(materialsView)
          .flat()
          .filter((mc) => !mc.excludeFromTa).length;
      default:
        break;
    }
  };

  const renderTab = (tab) => {
    const count = renderCount(tab.tabId);
    return (
      <li key={tab.tabId} className="nav-item">
        <div
          className={`nav-link border-secondary border-bottom-0 pointer-cursor ${
            tab.tabId === selectedTabId ? "active border ta-tab--border" : ""
          }`}
          id={tab.tabId + "_tab"}
          data-toggle="tab"
          role="tab"
          onClick={() => selectTab(tab.tabId)}
        >
          {tab.label}
          <span className={`badge badge-${count > 0 ? "primary" : "secondary"} ml-2`}>
            {count}
          </span>
        </div>
      </li>
    );
  };

  return (
    <ul className="nav nav-tabs border-0" role="tablist">
      {tabs.map((tab) => renderTab(tab))}
    </ul>
  );
}

export default AdrTentativeAgreementModalTabsV3;
